import * as React from 'react';
import { Link } from "react-router";
import * as Sauce from "Sauce";
import * as Immutable from "Immutable";
import { items as software_project_items } from "Showcase/ShowCaseItem";
import { ShowCase } from "Showcase/Component/ShowCase";
import { Lissajous } from "Math/ParametricCurve"
import { Plotter } from "UI/Math/Plotter";
import * as Rx from "rxjs";
import * as Util from "Util";

require("./MasonDotNet.scss");

export class MasonDotNet extends Sauce.Component<{}, {}> {
    constructor(props: Immutable.Collection<string, any>) {
        super(props);
    }
    
    render() {
        return React.DOM.div({ className: "container" },
            React.DOM.h1({}, "Mason Net"),
            React.DOM.div({ className: "math-showcase-description"}, "",
                <ul className ={"math-showcase"}>
                    <Link to="/parametric">
                        <li className={"lissajous"}>
                            <Plotter curves={[ {key: Util.makeDomId("Lissajous10,9"), value: new Lissajous(10, 9)}]} 
                                tmin={Math.PI * -1} 
                                tmax={Math.PI} 
                                xmin={-1} xmax={1} ymin={-1} ymax={1} 
                                numSamples={2000}/>
                                Virtual oscilloscope. Demonstrating the integration of React, d3, and RxJS in a performance-intensive application.
                        </li>
                    </Link>
                </ul>
                ),
            <div>{/*
                <h2>Software Projects</h2>
                <ShowCase items={software_project_items}/>
                */}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/code/MasonDotNet.tsx